module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-base text-primary"
  }, [_c('p-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "title": _vm.title,
      "transition": "pixel-header-fade-in-left",
      "right-options": _vm.rightOptions,
      "left-options": _vm.leftOptions
    },
    on: {
      "on-click-more": _vm.onClickMore
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "pixel-pop-out"
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1), _vm._v(" "), _c('mt-tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'appIndex' || _vm.$route.name == 'appMine'),
      expression: "$route.name=='appIndex'||$route.name=='appMine'"
    }],
    staticClass: "pixel-1px-t",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    attrs: {
      "id": "appIndex"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeTab('appIndex')
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-home",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v("\n            \t首页\n          \t")]), _vm._v(" "), _c('mt-tab-item', {
    attrs: {
      "id": "appMine"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changeTab('appMine')
      }
    }
  }, [_c('i', {
    staticClass: "icon iconfont icon-mine",
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v("\n            \t我的\n          \t")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-681bf772","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/AppBase.vue
// module id = 252
// module chunks = 3